export default __webpack_public_path__ + "static/media/Gauntlets of the Chaos Agent.a2ae554e.jpg";